{
    "button__in_1_week": "In 1 Woche",
    "button__in_4_week": "In 4 Wochen"
}
